import { authMe } from "../../../shared/api/auth/autMe";

export const getAuthData = async () => {
	const response = authMe();
	return response;
};
